import React, { Component } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, Spinner,
} from 'reactstrap'
import PdfRender from '../../components/Common/PdfReader'



class PdfView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pdfView: '',
      pdfViewIsLoading: false,
    }
  }
render(){
  const { pdfView, pdfViewIsLoading } = this.state
  const { toggle, isOpen, Path, Header } = this.props
          console.log("Path ", Path)
        return (
          <Modal
            centered
            size="lg"
            isOpen={isOpen}
          > 
          <ModalHeader>
            {Header}          
          </ModalHeader>
          <ModalBody>
              <PdfRender data={Path} />              
          </ModalBody>
          <ModalFooter>
          <Button
            color="light"
            disabled={pdfViewIsLoading}
            onClick={() => {
              toggle()
            }}
          >
            Cancelar
          </Button>
        </ModalFooter>
        
       </Modal>
 )
}
}

export default(PdfView)